// extracted by mini-css-extract-plugin
module.exports = {"FeedNewsBlock":"styles_FeedNewsBlock__6TGUy","title":"styles_title__315NL","footer":"styles_footer__3HJ-d","date":"styles_date__HEyBV","externalLink":"styles_externalLink__1cr1g"};